<div class="modal d-block" tabindex="-1" role="dialog" [class.show]="showModal">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{{ 'PEOPLE.SELECT_PEOPLE_MODAL.TITLE' | translate }}</h5>
        <button type="button" class="btn-close" aria-label="Close" (click)="closeModal()"></button>
      </div>
      <div class="modal-body">
        <form class="search-container" [formGroup]="search">
            <div class="row"> 
                <div class="col-md"> 
                    <div class="form-floating mb-2">
                        <input type="text" id="name" class="form-control" formControlName="name" placeholder="{{ 'COMMON.SEARCH.PEOPLE_NAME' | translate }}" />
                        <input type="hidden" id="teamId" class="form-control" formControlName="teamId" />
                        <label for="name">{{ 'COMMON.SEARCH.PEOPLE' | translate }}</label>
                        @if (search.controls.name.value) {
<button
                        type="button"
                        class="btn-clear-search"
                        (click)="resetSearchField('name')"
                        title="{{ 'COMMON.CLEAR_SEARCH' | translate }}"
                        >
                        <i class="bi bi-x-circle"></i> </button>
}
                    </div>
                </div>
            </div>
            <div class="row mb-4">
                <div class="col-md">
                    <div class="form-floating">
                        <select id="team" class="form-select" formControlName="teamId">
                        <option value="">{{ 'COMMON.SEARCH.ALL' | translate }}</option>
                        @for (team of teamsFilter$ | async; track team) {
<option [value]="team.id">{{ team.name }}</option>
}
                        </select>
                        <label for="team">{{ 'COMMON.SEARCH.TEAM' | translate }}</label>
                        @if (search.controls.teamId.value) {
<button
                        type="button"
                        class="btn-clear-search btn-clear-select"
                        (click)="resetSearchField('teamId')" title="{{ 'COMMON.CLEAR_FILTER' | translate }}"
                        >
                        <i class="bi bi-x-circle"></i>
                        </button>
}
                    </div>
                </div>
                <div class="col-md">
                    <div class="form-floating">
                        <select id="role" class="form-select" formControlName="roleId">
                        <option value="">{{ 'COMMON.SEARCH.ALL' | translate }}</option>
                        @for (role of rolesFilter$ | async; track role) {
<option [value]="role.id">{{ role.name }}</option>
}
                        </select>
                        <label for="role">{{ 'COMMON.SEARCH.ROLE' | translate }}</label>
                        @if (search.controls.roleId.value) {
<button
                        type="button"
                        class="btn-clear-search btn-clear-select"
                        (click)="resetSearchField('roleId')"
                        title="{{ 'COMMON.CLEAR_SEARCH' | translate }}"
                        >
                        <i class="bi bi-x-circle "></i> 
                        </button>
}
                    </div>
                </div>
            </div>
            <div class="row"> 
                <div class="col-md"> 
                    @if (people$ | async; as people) {

                    @if (people?.length) {
                        <ul class="list-group list-group-flush">
                        @for (person of people; track personTrackBy($index, person)) {
                        <li class="list-group-item list-group-item-action d-flex align-items-center" (click)="selectPerson(person)">
                            <app-avatar [personOrPeople]="person" size="normal" shape="circle" class="me-3"></app-avatar>

                            <div class="d-flex flex-column me-auto">
                            <span>{{ person.firstName }} {{ person.lastName }}</span>

                            <div class="d-flex align-items-center mt-1">
                                <span class="text-muted small me-2">{{ person.role?.name || 'No Role' }}</span>
                                <app-people-status [person]="person"></app-people-status>
                            </div>
                            </div>
                        </li>
                        }
                    </ul>
                    } @else {
                    <p class="text-muted text-center">{{ 'PEOPLE.SELECT_PEOPLE_MODAL.NO_PEOPLE_FOUND' | translate }}</p>
                    }
                    
}
                </div>
            </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-secondary" (click)="closeModal()">{{ 'COMMON.CANCEL' | translate }}</button>
        </div>
      </form>
    </div>
  </div>
</div>